import { RouterPathes } from 'shared/constants'

/**
 * Operation name of `getDemoCoinBalance`: a screen that changed the balance
 * (a bet accepted, a round settled) reads it again with
 * `client.refetchQueries({ include: [DEMO_COIN_BALANCE_QUERY] })`.
 */
export const DEMO_COIN_BALANCE_QUERY = 'getDemoCoinBalance'

/** The title of every refusal of a stake the demo coins do not cover. */
export const INSUFFICIENT_DEMO_COINS_TITLE = 'Not enough demo coins'

/** The header's name of the balance. */
export const DEMO_COIN_BALANCE_LABEL = 'Demo coins'

/**
 * The daily tasks on the Rewards page (the section's `id`): a claimed task
 * adds demo coins, so every "not enough demo coins" leads there.
 */
export const DAILY_TASKS_PATH = `${RouterPathes.rewards}#daily-tasks`

/** The link and toast button to `DAILY_TASKS_PATH`. */
export const DAILY_TASKS_LINK_TEXT = 'Daily tasks'
